export default __webpack_public_path__ + "static/media/part2_img.ef15c78e.png";